'use client'

import { Button, Icon } from '@graftcode/design-system'

import styles from './CardHeader.module.scss'

interface CardHeaderProps {
  label: string
  count?: number
  description?: string
  onBack?: () => void
}

function handleTitleRowKeyDown(e: React.KeyboardEvent, onBack: () => void) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    onBack()
  }
}

export function CardHeader({ label, count, description, onBack }: CardHeaderProps) {
  return (
    <div className={styles.mobileHeader}>
      <div
        className={styles.titleRow}
        role={onBack ? 'button' : undefined}
        tabIndex={onBack ? 0 : undefined}
        aria-label={onBack ? 'Go back' : undefined}
        onClick={onBack}
        onKeyDown={onBack ? (e) => handleTitleRowKeyDown(e, onBack) : undefined}
      >
        {onBack && <Button iconOnly size="l" variant="ghost" icon={Icon.ChevronLeftRegular} aria-hidden />}
        <div className={styles.titleContent}>
          <span className={styles.label}>{label}</span>
          {typeof count === 'number' && <span className={styles.count}>({count})</span>}
        </div>
      </div>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  )
}
